import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-nursingstation',
  templateUrl: './nursingstation.component.html',
  styleUrls: []
})
export class NursingStationComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/nursingstation/nursingstation.component.ts